import { formatDateTime, formatNumber } from "@/lib/format";

export default function SignupDetails({ application }) {
  const address = [application.school_address, application.city, application.province, application.postal_code].filter(Boolean).join(", ");
  return (
    <section className="rounded-xl border border-border bg-card overflow-hidden">
      <header className="border-b border-border px-4 py-3">
        <h2 className="font-display text-lg font-semibold">Signup details</h2>
        <p className="mt-1 text-xs text-muted-foreground">Original answers · {formatDateTime(application.submitted_at)}</p>
      </header>
      <dl className="divide-y divide-border px-4 text-xs">
        <Answer label="Applicant">{application.applicant_name}{application.applicant_role && ` · ${application.applicant_role}`}<a href={`mailto:${application.applicant_email}`} className="block mt-1 text-primary hover:underline break-all">{application.applicant_email}</a></Answer>
        <Answer label="School">{application.school_name}<p className="mt-1 text-muted-foreground">{address || "Address not provided"}</p></Answer>
        <Answer label="Students">{application.estimated_students == null ? "Not provided" : `${formatNumber(application.estimated_students)} estimated`}</Answer>
        <Answer label="Proposed dates">{application.campaign_dates_label}</Answer>
        <Answer label="Payment account">{application.payment_processor_label}</Answer>
        <Answer label="Heard via">{application.heard_about_us || "Not provided"}</Answer>
        {application.notes && <Answer label="Notes"><p className="whitespace-pre-wrap">{application.notes}</p></Answer>}
        {(application.reviewed_at || application.reviewed_by || application.review_notes) && (
          <Answer label="Review">
            {application.reviewed_by && <p>{application.reviewed_by}</p>}
            {application.reviewed_at && <p className="mt-1 text-muted-foreground">{formatDateTime(application.reviewed_at)}</p>}
            {application.review_notes && <p className="mt-1 whitespace-pre-wrap">{application.review_notes}</p>}
          </Answer>
        )}
      </dl>
    </section>
  );
}

function Answer({ label, children }) {
  return <div className="grid grid-cols-[6rem_minmax(0,1fr)] gap-3 py-3"><dt className="text-muted-foreground">{label}</dt><dd className="min-w-0 break-words">{children}</dd></div>;
}
